export default __webpack_public_path__ + "static/media/course-bg.460d7c6a.jpg";